import { useState } from 'react';
import { Outlet } from 'react-router-dom';

// @mui
import { Grid, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import { makeStyles, withStyles } from '@mui/styles';
import useResponsive from '../../hooks/useResponsive';
import { getAssetsUrl } from '../../utils/@helper/file.helper';
import { fDateYear } from '../../utils/formatTime';

// ==================================|| STYLED ||================================== //

const StyledSection = styled('div')(({ theme }) => {
  return {
    padding: theme.spacing(3),
    position: 'relative',
    width: '100%',
    minHeight: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    boxShadow: theme.customShadows.card,
    backgroundColor: theme.palette.background.default,
    backgroundRepeat: 'no-repeat',
    backgroundOrigin: 'border-box',
    backgroundPosition: 'center',
    backgroundSize: 'cover',
    backgroundImage: `url("${getAssetsUrl('images/img-login-cover@2x.png')}")`,
  }
});


const useStyles = makeStyles((theme)=>{
  return ({
    SimCompanyCardContainer: {
      position: 'absolute',
      top: theme.spacing(3),
      left: theme.spacing(3),
      width: '416px',
      'backdrop-filter': 'blur(20px)',
      '-webkit-backdrop-filter': 'blur(20px)',
      'box-shadow': '0 2px 1px rgba(30, 34, 40, 0.02), 0 4px 2px rgba(30, 34, 40, 0.02), 0 8px 4px rgba(30, 34, 40, 0.02), 0 16px 8px rgba(30, 34, 40, 0.02), 0 32px 16px rgba(30, 34, 40, 0.03)',
      padding: theme.spacing(3),
      margin: theme.spacing(0),
      borderRadius: theme.spacing(1.5),
    },
    SimCompanyCardHeader: {
      marginBottom: theme.spacing(1.5)
    },
    SimCompanyCardContent: {
      marginLeft: '0px',
      display: 'grid',
      gridTemplateColumns: 'repeat(auto-fill, minmax(auto, 112px))'
    },
    SimCompanyLink: {
      marginBottom: theme.spacing(0.5)
    },

    SimLoginCardContainer: {
      position: 'absolute',
      bottom: theme.spacing(3),
      right: theme.spacing(3),
      'backdrop-filter': 'blur(20px)',
      '-webkit-backdrop-filter': 'blur(20px)',
      'box-shadow': '0 2px 1px rgba(30, 34, 40, 0.02), 0 4px 2px rgba(30, 34, 40, 0.02), 0 8px 4px rgba(30, 34, 40, 0.02), 0 16px 8px rgba(30, 34, 40, 0.02), 0 32px 16px rgba(30, 34, 40, 0.03)',
      padding: theme.spacing(3),
      'border-radius': theme.spacing(2.5),
      '&:after': {
        content: '""',
        display: 'block',
        position: 'absolute',
        top: '0px',
        left: '0px',
        width: '180px',
        height: '180px',
        borderRadius: '100%',
        backgroundColor: '#6e45e2',
        filter: 'blur(70px)',
        zIndex: -1,
      }
    },
    SimLoginCardHeader: {
      marginBottom: theme.spacing(1.5)
    },
    SimLoginCardContent: {
      marginLeft: '0px',
      marginBottom: theme.spacing(0.5),
      color: 'rgb(0, 0, 0)'
    }
  })
});

const MyComponent = withStyles({
  root: {
    backgroundColor: 'red',
  },
})(({ classes }) => (
  <div className={classes.root}>2423</div>
));

// ==================================|| SESSION LAYOUT ||================================== //

export default function SessionLayout() {
  const classes = useStyles();
  const mdUp = useResponsive('up', 'md');
  const [open, setOpen] = useState(false);

  return (
    <Grid container spacing={0} sx={{ minHeight: '100vh', overflowX: 'hidden', backgroundColor: theme => theme.palette.background.paper, }}>
      <Grid item xs={false} sm={false} md={6} lg={6}>
         {mdUp && (
          <StyledSection>
            {/* BG IMG */}
          </StyledSection>
        )}
      </Grid>
      <Grid item xs={12} sm={12} md={6} lg={6}
        sx={{
          display: 'grid',
          gridTemplateRows: 'calc(100% - 35px) 0',
        }}
      >
        <Outlet />
        <Typography variant={'caption'} textAlign={'center'} color={theme => theme.palette.grey[600]}>Copyright © { fDateYear(new Date()) } 鴻海精密工業股份有限公司著作權所有</Typography>
      </Grid>
    </Grid>
  )
}
